<template>
  <a-modal :title="form.navid ? '修改导航栏信息' : '新增导航栏信息'" :visible="visible" :confirm-loading="confirmLoading"
    @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false" width="500px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="导航栏名称" prop="title">
        <a-input v-model="form.title" placeholder="请输入导航栏名称" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="state">
        <a-radio-group v-model="form.state">
          <a-radio value="1">启用</a-radio>
          <a-radio value="2">禁用</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input-number v-model="form.sort" :min="0" style="width: 50%;" placeholder="请输入排序" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        navid: "",
        title: '',
        state: '1',//状态
        sort: 0,
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        title: [
          {
            required: true,
            message: "请输入导航栏名称",
            trigger: "change",
          },
        ],
        state: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.navid = id;
      if (id) {
        this.$http({
          url: "/admin/appnav/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = { ...res.data };
        });
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.navid
              ? "/admin/appnav/update"
              : "/admin/appnav/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(this.form.navid ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style></style>